// extracted by mini-css-extract-plugin
export var card = "_8t-0";
export var failedIcon = "_8t-4";
export var failedIconBadge = "_8t-3";
export var icon = "_8t-1";
export var successIcon = "_8t-2";